import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSetChatManager = {
  setChatManager: { data: null, loading: false, error: null },
};

export const setChatManager = createAsyncThunk('user/setChatManager', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/chat/chats/${data.chatId}/manager`,
      { manager_id: data.managerId },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSetChatManager = {
  [setChatManager.pending]: (state) => {
    // state.setChatManager.data = null;
    state.setChatManager.loading = true;
    state.setChatManager.error = null;
  },
  [setChatManager.fulfilled]: (state, action) => {
    state.setChatManager.loading = false;
    state.setChatManager.data = action.payload;
    state.setChatManager.error = null;
  },
  [setChatManager.rejected]: (state, action) => {
    state.setChatManager.loading = false;
    state.setChatManager.error = action.payload;
  },
};
